/** @format */

// import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const ChatEntePagePropTypes = exact({});

export default ChatEntePagePropTypes;
